import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import { FaEye, FaEyeSlash, FaTimes } from "react-icons/fa";
import LoadingSpinner from '../utils/LoadingSpinner';

const LoginPage = () => {
    const [formData, setFormData] = useState({
        username: "",
        password: "",
    });
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState("");
    const [fieldErrors, setFieldErrors] = useState({
        username: "",
        password: ""
    });
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const { login } = useContext(AuthContext);
    const navigate = useNavigate();

    useEffect(() => {
        // Récupérer le dernier nom d'utilisateur connecté depuis le localStorage
        const lastUserLogin = localStorage.getItem("lastUserLogin");
        if (lastUserLogin) {
            setFormData(prev => ({
                ...prev,
                username: lastUserLogin
            }));
        }
    }, []);

    const validateField = (name, value) => {
        let error = "";
        if (!value.trim()) {
            error = "Ce champ est requis";
        } else if (/\s/.test(value)) {
            error = "Ce champ ne doit pas contenir d'espaces";
        }
        return error;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Validation en temps réel
        const error = validateField(name, value);
        setFieldErrors(prev => ({
            ...prev,
            [name]: error
        }));
        if (error) setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        // Validation avant soumission
        const usernameError = validateField('username', formData.username);
        const passwordError = validateField('password', formData.password);

        if (usernameError || passwordError) {
            setFieldErrors({
                username: usernameError,
                password: passwordError
            });
            return;
        }

        setIsButtonLoading(true);
        try {
            await new Promise((resolve) => setTimeout(resolve, 3000));
            setIsButtonLoading(false);
            setIsPageLoading(true);
            await new Promise((resolve) => setTimeout(resolve, 3000));

            // Convertir le username en minuscules avant l'envoi
            const lowercaseUsername = formData.username.toLowerCase();
            await login(lowercaseUsername, formData.password);

            // Stocker le nom d'utilisateur dans le localStorage
            localStorage.setItem("lastUserLogin", formData.username);
            navigate("/home", { replace: true });
        } catch (err) {
            if (err.response?.data?.message === "User not found") {
                setError(<div style={{ textAlign: 'left' }}>
                    <strong style={{ color: '#db1717c4', fontSize: '1.2em' }}>Erreur ! 😞</strong><br />
                    Identifiant incorrect, vérifiez vos identifiants puis recommencez.
                </div>);
            } else {
                setError(err.response?.data?.message || "Une erreur est survenue lors de la connexion");
            }
        } finally {
            setIsButtonLoading(false);
            setIsPageLoading(false);
        }
    };

    const handleCloseError = () => {
        setError("");
    };

    return (
        <>
            {isPageLoading && <LoadingSpinner isVisible={true} loadingText="Connexion en cours..." />}
            <div className="">
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    maxWidth: '600px',
                    margin: '0 auto',
                    padding: '20px'
                }}>
                    <div className="verify-number-main" style={{
                        marginTop: "10%",
                        borderRadius: '5%',
                        width: '100%',
                        maxWidth: '100%'
                    }}>
                        <div className="verify-number-top">
                            <div className="container">
                                <Link to="/">
                                    <div className="text-center" style={{ paddingTop: "10px" }}>
                                        <img
                                            src="assets/images/logo/logo.png"
                                            alt="Logo NTR Finance"
                                            style={{ width: "150px", marginBottom: "20px", borderRadius: "50%" }}
                                        />
                                        <h1
                                            className="app-name"
                                            style={{
                                                fontSize: "24px",
                                                fontWeight: "bold",
                                                margin: "10px 0",
                                                color: "#fff",
                                            }}
                                        >
                                            NTR Finance
                                        </h1>
                                        <div className="header-title">
                                            <p>Connexion</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className="verify-number-bottom" style={{
                            borderBottomLeftRadius: '5%',
                            borderBottomRightRadius: '5%',
                            minHeight: '10%'
                        }}>
                            <div className="verify-number-bottom-wrap">
                                <form id="msform" onSubmit={handleSubmit}>
                                    {error && (
                                        <div
                                            className="alert alert-danger d-flex justify-content-between align-items-center"
                                            role="alert">
                                            <span>{error}</span>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={handleCloseError}
                                                style={{ background: 'none', border: 'none' }}
                                            >
                                                <FaTimes />
                                            </button>
                                        </div>
                                    )}
                                    <div className="multistep-form">
                                        <div className="form-floating mt-24">
                                            <input
                                                type="text"
                                                name="username"
                                                value={formData.username}
                                                onChange={handleChange}
                                                className={`form-control ${fieldErrors.username ? 'is-invalid' : ''}`}
                                                placeholder="Nom d'utilisateur"
                                                disabled={isButtonLoading || isPageLoading}
                                                autoComplete="off"
                                            />
                                            <label>Nom d'utilisateur</label>
                                            {fieldErrors.username && (
                                                <div className="invalid-feedback">{fieldErrors.username}</div>
                                            )}
                                        </div>
                                        <div className="form-floating mt-24 position-relative">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                className={`form-control ${fieldErrors.password ? 'is-invalid' : ''}`}
                                                placeholder="Mot de passe"
                                                disabled={isButtonLoading || isPageLoading}
                                                autoComplete="off"
                                            />
                                            <label>Mot de passe</label>
                                            <button
                                                type="button"
                                                className="btn btn-link position-absolute end-0 translate-middle-y"
                                                onClick={() => setShowPassword(!showPassword)}
                                                style={{
                                                    zIndex: 5,
                                                    background: "none",
                                                    border: "none",
                                                    padding: "0.375rem 0.75rem",
                                                    top: "40%",
                                                    paddingRight: "30px",
                                                    fontSize: "35px",
                                                }}
                                            >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                            </button>
                                            {fieldErrors.password && (
                                                <div className="invalid-feedback">{fieldErrors.password}</div>
                                            )}
                                        </div>
                                        <div className="mt-3 text-center">
                                            <Link to="/reset-password1" className="text-decoration-none" style={{ fontWeight: 'bold' }}>
                                                Mot de passe oublié ?
                                            </Link>
                                        </div>
                                        <div className="mt-3 text-center">
                                            <Link to="/retrieve-username" className="text-decoration-none" style={{ fontWeight: 'bold' }}>
                                                Identifiant de connexion oublié ?
                                            </Link>
                                        </div>
                                        <div className="mt-4">
                                            <button
                                                type="submit"
                                                className="btn btn-primary w-100"
                                                disabled={isButtonLoading || isPageLoading}
                                            >
                                                {isButtonLoading ? (
                                                    <>
                                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        Connexion en cours...
                                                    </>
                                                ) : (
                                                    "Se connecter"
                                                )}
                                            </button>
                                        </div>
                                        <div className="mt-32 text-center" style={{ fontSize: '20px', fontWeight: 'bold', }}>
                                            <span>Pas encore inscrit ? </span>
                                            <Link to="/register" className="text-decoration-none">
                                                Créer un compte
                                            </Link>
                                        </div>

                                        <div className="mt-32 text-center" style={{ fontSize: '16px', fontWeight: 'bold', paddingBottom: '50px' }}>
                                            <Link to="/privacy_policy" className="text-decoration-none">
                                                Politique de confidentialité
                                            </Link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoginPage;
